'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = exports.AppUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactIntl = require('react-intl');

var _cookiePolicyHelper = require('helpers/cookiePolicyHelper');

var cookiePolicyHelper = _interopRequireWildcard(_cookiePolicyHelper);

var _userTypeCookie = require('helpers/userTypeCookie');

var userTypeCookie = _interopRequireWildcard(_userTypeCookie);

var _utmValues = require('helpers/utmValues');

var utmValues = _interopRequireWildcard(_utmValues);

var _DisclaimerModal = require('components/DisclaimerModal/DisclaimerModal');

var _Footer = require('components/Footer/Footer');

var _FullScreenError = require('components/Errors/FullScreenError');

var _RetainSDK = require('components/RetainSDK/RetainSDK');

var _FullStorySDK = require('components/FullStorySDK/FullStorySDK');

var _GoogleAnalytics = require('components/GoogleAnalytics/GoogleAnalytics');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _LoadingBar = require('components/LoadingBar/LoadingBar');

var _MediaListener = require('components/MediaListener');

var _ModalHost = require('components/ModalHost/ModalHost');

var _CmsModalLoader = require('components/CmsModals/CmsModalLoader');

var _SnowplowTracker = require('components/SnowplowTracker/SnowplowTracker');

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _isMobile = require('helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _bound = require('redux/saga/entities/bound');

var _statsd = require('helpers/statsd');

var _selectors = require('redux/saga/selectors');

var _page = require('redux/modules/page');

var _device = require('redux/modules/device');

var _BannerHost = require('features/Banners/BannerHost');

var _CmsBannerLoader = require('features/Banners/CmsBannerLoader');

var _announcements = require('containers/Announcements/announcements.saga');

var _AppHeader = require('components/AppHeader/AppHeader');

var _app = require('./app.saga');

var _appReferAFriend = require('./app-refer-a-friend.saga');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('../../styles/main.scss'); /**
                                    * This is the top level view which the entire app is rendered in to
                                    */

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    config: state.config,
    continent: state.locale.continent,
    currentRouterPath: ownProps.location.pathname + (ownProps.location.search || ''),
    error: state.error,
    page: state.page,
    flags: state.page.flags,
    currentFullUrl: state.request.currentFullUrl,
    query: state.request.query,
    visitorId: state.request.visitorId,
    userProfile: _bound.userProfile.data(state),
    userPermissions: _bound.userPermissions.data(state),
    userCreditBalance: _bound.userCreditBalance.data(state, (0, _selectors.scheduleContext)(state)),
    showCookiePolicy: state.page.showCookiePolicy
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  loadInitialApp: _app.loadInitialApp,
  loadAnnouncements: _announcements.loadAnnouncements,
  setLogoLink: _page.setLogoLink,
  showReferAFriendBanner: _appReferAFriend.showReferAFriendBanner,
  toggleFlag: _page.toggleFlag,
  setIsClient: _device.setIsClient
};

var messages = (0, _reactIntl.defineMessages)({
  description: {
    id: 'App.description',
    defaultMessage: 'Work out at the best studios in your city'
  },
  ogTitle: {
    id: 'App.ogTitle',
    defaultMessage: 'ClassPass - Work out at the best studios in your city'
  },
  ogSite_name: {
    id: 'App.ogSite_name',
    defaultMessage: 'ClassPass'
  }
});

var AppUnwrapped = exports.AppUnwrapped = function (_Component) {
  (0, _inherits3.default)(AppUnwrapped, _Component);

  function AppUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, AppUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = AppUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(AppUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleDocumentClick = function () {
      var _this$props = _this.props,
          flags = _this$props.flags,
          localToggleFlag = _this$props.toggleFlag;


      if ((0, _isMobile2.default)() && flags.headerAccountDropdownOpen) {
        localToggleFlag('headerAccountDropdownOpen');
      }
    }, _this2.shouldShowCookiePolicy = function () {
      var _this$props2 = _this.props,
          continent = _this$props2.continent,
          flags = _this$props2.flags,
          location = _this$props2.location;


      return (__CLIENT__ || __TEST__) && continent === 'europe' && !_this.seenCookiePolicy && flags.showCookiePolicy && !(0, _isMobile.isWebview)(location.search);
    }, _this2.maybeSetLogoLink = function () {
      var _this$props3 = _this.props,
          localSetLogoLink = _this$props3.setLogoLink,
          localUserPermissions = _this$props3.userPermissions;

      if (localUserPermissions && localUserPermissions.feature_hide_classes) {
        localSetLogoLink('/videos');
      }
    }, _this2.showAnnouncements = function () {
      var localLoadAnnouncements = _this.props.loadAnnouncements;


      localLoadAnnouncements();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(AppUnwrapped, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.loadInitialApp();
      this.maybeSetLogoLink();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          currentRouterPath = _props.currentRouterPath,
          localUserProfile = _props.userProfile,
          localSetIsClient = _props.setIsClient,
          localShowReferAFriendBanner = _props.showReferAFriendBanner;


      utmValues.saveToCookie(currentRouterPath);
      userTypeCookie.setFromProfile(localUserProfile);
      window.addEventListener('unload', _statsd.flush);

      if ((__CLIENT__ || __TEST__) && this.seenCookiePolicy === undefined) {
        this.seenCookiePolicy = cookiePolicyHelper.hasSeenCookiePolicy();
        cookiePolicyHelper.set(true);
      }

      localShowReferAFriendBanner();
      this.showAnnouncements();
      localSetIsClient(true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          currentRouterPath = _props2.currentRouterPath,
          localUserProfile = _props2.userProfile;


      if (__CLIENT__) {
        if (nextProps.currentRouterPath !== currentRouterPath) {
          window.scrollTo(0, 0);
        }
        if (!localUserProfile && nextProps.userProfile) {
          userTypeCookie.setFromProfile(nextProps.userProfile);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          localConfig = _props3.config,
          currentFullUrl = _props3.currentFullUrl,
          currentRouterPath = _props3.currentRouterPath,
          error = _props3.error,
          page = _props3.page,
          query = _props3.query,
          localToggleFlag = _props3.toggleFlag,
          localUserProfile = _props3.userProfile,
          visitorId = _props3.visitorId,
          intl = _props3.intl;


      var config = (0, _universalConfig2.default)();

      var app = _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_MediaListener.MediaListener, null),
        _react2.default.createElement(
          _reactHelmet2.default,
          null,
          _react2.default.createElement('meta', { charSet: 'utf-8' }),
          _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1' }),
          _react2.default.createElement('meta', { name: 'description', content: intl.formatMessage(messages.description) }),
          _react2.default.createElement('meta', { property: 'og:title', content: intl.formatMessage(messages.ogTitle) }),
          _react2.default.createElement('meta', { property: 'og:url', content: currentFullUrl }),
          _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
          _react2.default.createElement('meta', { property: 'og:site_name', content: intl.formatMessage(messages.ogSite_name) }),
          _react2.default.createElement('meta', { property: 'og:image', content: require('../../../static/img/facebook-image-yoga.jpg') }),
          _react2.default.createElement('meta', { property: 'fb:app_id', content: config && config.fb && config.fb.appId }),
          _react2.default.createElement('meta', { property: 'p:domain_verify', content: 'ed77031fc6389d9c85c24dd3a1cad7d5' }),
          _react2.default.createElement('meta', { property: 'apple-mobile-web-app-capable', content: 'yes' }),
          _react2.default.createElement('meta', { property: 'mobile-web-app-capable', content: 'yes' }),
          _react2.default.createElement('link', { rel: 'shortcut icon', content: '/favicon.ico' }),
          _react2.default.createElement('link', { rel: 'dns-prefetch', content: '//hello.myfonts.net' })
        ),
        _react2.default.createElement(_ModalHost.ModalHost, null),
        _react2.default.createElement(_CmsModalLoader.CmsModalLoader, null),
        _react2.default.createElement(_BannerHost.BannerHost, { category: 'announcement' }),
        _react2.default.createElement(_CmsBannerLoader.CmsBannerLoader, null),
        _react2.default.createElement(_AppHeader.AppHeaderContainer, null),
        _react2.default.createElement(_BannerHost.BannerHost, { category: 'notification' }),
        _react2.default.createElement(
          'div',
          { className: 'body__content' },
          _react2.default.createElement(_LoadingBar.LoadingBar, { percentLoaded: page.loadingBarPercent }),
          error ? _react2.default.createElement(_FullScreenError.FullScreenError, { error: error }) : children,
          this.shouldShowCookiePolicy() && _react2.default.createElement(_DisclaimerModal.DisclaimerModal, {
            onClose: localToggleFlag.bind(this, 'showCookiePolicy'),
            text: _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'cookie-policy.text',
              defaultMessage: 'This website uses cookies including to improve its functionality and performance. By continuing to browse the site you are accepting our use of cookies. To find out more about the cookies we use, please read our {privacy} and {cookie}.',
              values: {
                privacy: _react2.default.createElement(
                  'a',
                  { href: '/privacy' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'privacy-policy',
                    defaultMessage: 'privacy policy'
                  })
                ),
                cookie: _react2.default.createElement(
                  'a',
                  { href: '/privacy#cookies' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'cookie-policy',
                    defaultMessage: 'cookie policy'
                  })
                )
              }
            })
          })
        ),
        _react2.default.createElement(_Footer.FooterContainer, null)
      );

      if (query.disableTrackers) {
        return app;
      }

      return _react2.default.createElement(
        _react.StrictMode,
        null,
        _react2.default.createElement(_SnowplowTracker.SnowplowTracker, {
          host: localConfig.snowplow.host,
          appId: localConfig.snowplow.appId
        }),
        app,
        _react2.default.createElement(_GoogleAnalytics.GoogleAnalytics, {
          userId: localUserProfile && localUserProfile.id,
          currentPath: currentRouterPath,
          accountKey: localConfig.googleAnalytics.key,
          cookieDomain: localConfig.googleAnalytics.cookieDomain
        }),
        _react2.default.createElement(_GoogleTagManager.GoogleTagManager, {
          userId: localUserProfile && localUserProfile.id,
          containerId: localConfig.googleTagManager.container
        }),
        _react2.default.createElement(_FullStorySDK.FullStorySDK, {
          currentUser: localUserProfile,
          currentPath: currentRouterPath,
          visitorId: visitorId
        }),
        _react2.default.createElement(_RetainSDK.RetainSDK, {
          currentUser: localUserProfile,
          accountKey: localConfig.retain.appKey
        }),
        _react2.default.createElement(
          _reactHelmet2.default,
          null,
          _react2.default.createElement('link', { rel: 'prefetch', href: 'https://cdn.optimizely.com/js/' + localConfig.optimizely.projectId + '.js' }),
          _react2.default.createElement('link', { rel: 'preconnect', href: '//logx.optimizely.com' })
        )
      );
    }
  }]);
  return AppUnwrapped;
}(_react.Component);

AppUnwrapped.contextTypes = {
  store: _propTypes2.default.object.isRequired
};

AppUnwrapped.propTypes = {
  children: _propTypes2.default.object.isRequired,
  config: _propTypes2.default.object.isRequired,
  continent: _propTypes2.default.string.isRequired,
  currentFullUrl: _propTypes2.default.string.isRequired,
  currentRouterPath: _propTypes2.default.string.isRequired,
  error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
  flags: _propTypes2.default.object.isRequired,
  loadInitialApp: _propTypes2.default.func.isRequired,
  loadAnnouncements: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.object,
  page: _propTypes2.default.object.isRequired,
  query: _propTypes2.default.object.isRequired,
  setLogoLink: _propTypes2.default.func,
  showReferAFriendBanner: _propTypes2.default.func.isRequired,
  toggleFlag: _propTypes2.default.func.isRequired,
  userProfile: _propTypes2.default.object,
  userPermissions: _propTypes2.default.object,
  visitorId: _propTypes2.default.string,
  setIsClient: _propTypes2.default.func.isRequired,
  intl: _reactIntl.intlShape.isRequired
};

AppUnwrapped.sagas = [_app.watchLoadInitialApp, _appReferAFriend.watchReferAFriendBanner, _announcements.watchAnnouncements];

var App = exports.App = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(AppUnwrapped));